export enum MUTATION_KEYS {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
}

export default MUTATION_KEYS
